import { render } from "./BatchClassAttributes.vue?vue&type=template&id=5e6c38ca&scoped=true&ts=true"
import script from "./BatchClassAttributes.vue?vue&type=script&lang=ts"
export * from "./BatchClassAttributes.vue?vue&type=script&lang=ts"

import "./BatchClassAttributes.vue?vue&type=style&index=0&id=5e6c38ca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6c38ca"]])

export default __exports__